import { api } from "./api";

export const tenantService = {
  async getTenantDetails(): Promise<any> {
    const url = "/Mobile/Tenants/Details";

    const serverResponse = await api.get(url);

    if (serverResponse !== undefined) {
      return serverResponse.data;
    }

    throw Error;
  },
};
